import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { setPageTitle } from '../redux/slice/pageTitleSlice'
import { useDispatch, useSelector } from 'react-redux'
import { allCrudNames, allPages, checkPageAccess } from '../../lib/AllPageNames'
import NotFound from '../NotFound/NotFound'
import InvoiceList from './InvoiceList'

const InvoiceTabbing = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setPageTitle('Customer Invoice List'))
  }, [])

  const { pageAccess } = useSelector((state) => state.user)

  const [activeToggle, setActiveToggle] = useState('invoiceList')
  return checkPageAccess(
    pageAccess,
    allPages?.CustomerInvoice,
    allCrudNames?.read
  ) ? (
    <>
      <div className='card overflow-hidden'>
        <div className='card-body p-0'>
          <div className='nav-tabs-horizontal nav nav-tabs'>
            {checkPageAccess(
              pageAccess,
              allPages?.CustomerInvoice,
              allCrudNames?.read
            ) && (
              <Link
                onClick={() => setActiveToggle('invoiceList')}
                data-toggle='tab'
                className={`nav-link fw-semibold ${
                  activeToggle === 'invoiceList' ? 'active show' : ''
                }`}
              >
                <span className='nav-span'>
                  Customer Invoice
                  <hr />
                </span>
              </Link>
            )}
          </div>

          <div className='tab-content p-3'>
            {checkPageAccess(
              pageAccess,
              allPages?.CustomerInvoice,
              allCrudNames?.read
            ) && (
              <div
                id='order'
                className={`tab-pane fade ${
                  activeToggle === 'invoiceList' ? 'active show' : ''
                }`}
              >
                {activeToggle === 'invoiceList' && <InvoiceList />}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  ) : (
    <NotFound />
  )
}

export default InvoiceTabbing
